<template>
  <Tooltip
    isMarkdown
    :text="tooltipText"
  >
    <StatusBadge
      :status="status"
      :text="statusText"
    />
  </Tooltip>
</template>

<script>
// Components
import { StatusBadge, Tooltip } from '@jumpcloud/ui-components';

export default {
  name: 'StatusBadgeWithTooltip',

  components: {
    StatusBadge,
    Tooltip,
  },

  props: {
    status: {
      type: String,
      required: true,
    },
    statusText: {
      type: String,
      required: true,
    },
    tooltipText: {
      type: String,
      required: true,
    },
  },
};
</script>
